module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repo-content"
  }, [_c('div', {
    staticClass: "repo-title"
  }, [_c('text-holder', {
    attrs: {
      "width": "150px",
      "height": "23px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.repo.name) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repo-desc"
  }, [_c('text-holder', {
    attrs: {
      "width": "260px",
      "height": "21px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.repo.description) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repo-date"
  }, [_c('text-holder', {
    attrs: {
      "width": "80px",
      "height": "12px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("fromNow")(_vm.repo.updated_at)) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repo-info"
  }, [_c('div', {
    staticClass: "repo-language"
  }, [_c('text-holder', {
    attrs: {
      "width": "100px",
      "height": "15px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.repo.language) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repo-stats"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" " + _vm._s(_vm.repo.watchers_count) + "\n          "), _c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" " + _vm._s(_vm.repo.stargazers_count) + "\n          "), _c('i', {
    staticClass: "fa fa-code-fork"
  }), _vm._v(" " + _vm._s(_vm.repo.forks) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-644eb922!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepoContent.vue
// module id = 461
// module chunks = 2